// extracted by mini-css-extract-plugin
module.exports = {"AARS":"RiverAdvPC_AARS__H9YQ1"};